document.addEventListener("DOMContentLoaded", () => {
  initialiseTapNexAnimations();
  initialiseTapNexGallery();
  initialiseTapNexVariants();
});

function initialiseTapNexAnimations() {
  const elements = document.querySelectorAll(".tn-reveal");

  if (!("IntersectionObserver" in window)) {
    elements.forEach((element) => {
      element.classList.add("is-visible");
    });

    return;
  }

  const observer = new IntersectionObserver(
    (entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add("is-visible");
        currentObserver.unobserve(entry.target);
      });
    },
    {
      threshold: 0.12
    }
  );

  elements.forEach((element) => {
    observer.observe(element);
  });
}

function initialiseTapNexGallery() {
  const mainImage = document.querySelector("#TapNexMainImage");
  const thumbnails = document.querySelectorAll(".tn-thumbnail");

  if (!mainImage || !thumbnails.length) {
    return;
  }

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", () => {
      const imageUrl = thumbnail.dataset.fullImage;
      const altText = thumbnail.dataset.alt || "";

      if (!imageUrl) {
        return;
      }

      mainImage.src = imageUrl;
      mainImage.srcset = "";
      mainImage.alt = altText;

      thumbnails.forEach((item) => {
        item.classList.remove("is-active");
      });

      thumbnail.classList.add("is-active");
    });
  });
}

function initialiseTapNexVariants() {
  const variantInputs = document.querySelectorAll(
    '.tn-variant-option input[name="id"]'
  );

  const currentPrice = document.querySelector("#TapNexCurrentPrice");

  variantInputs.forEach((input) => {
    input.addEventListener("change", () => {
      document
        .querySelectorAll(".tn-variant-option")
        .forEach((option) => {
          option.classList.remove("is-selected");
        });

      const selectedOption = input.closest(".tn-variant-option");
      selectedOption?.classList.add("is-selected");

      if (currentPrice && input.dataset.price) {
        currentPrice.textContent = input.dataset.price;
      }

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("variant", input.value);

      window.history.replaceState({}, "", newUrl.toString());
    });
  });
}